const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_8x6fDOtF5",
  ClientId: "2vjivvpu7pi8d0cmab221omipp"
}
export default awsConfiguration
